import { render, staticRenderFns } from "./LightboxModal.vue?vue&type=template&id=4f050d4e&scoped=true"
import script from "./LightboxModal.vue?vue&type=script&lang=js"
export * from "./LightboxModal.vue?vue&type=script&lang=js"
import style0 from "./LightboxModal.vue?vue&type=style&index=0&id=4f050d4e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f050d4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f050d4e')) {
      api.createRecord('4f050d4e', component.options)
    } else {
      api.reload('4f050d4e', component.options)
    }
    module.hot.accept("./LightboxModal.vue?vue&type=template&id=4f050d4e&scoped=true", function () {
      api.rerender('4f050d4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/LightboxModal.vue"
export default component.exports